import { render, staticRenderFns } from "./specialPage.vue?vue&type=template&id=bfb2f8fa&scoped=true"
import script from "./specialPage.vue?vue&type=script&lang=js"
export * from "./specialPage.vue?vue&type=script&lang=js"
import style0 from "./specialPage.vue?vue&type=style&index=0&id=bfb2f8fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb2f8fa",
  null
  
)

export default component.exports